"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactImask = require("react-imask");
var _ContentEditable = _interopRequireDefault(require("../ContentEditable"));
var _utils = _interopRequireDefault(require("../utils/utils"));
var _forwardRef = _interopRequireDefault(require("../HOC/forwardRef"));
const _excluded = ["id", "visibility", "multilineType", "multilineSpellCheck", "onUpload", "onChange", "readOnly", "rows", "multiline", "inputRef", "type", "inputMode", "mask", "maskOptions", "autoComplete", "dataTestId"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ContentEditCom = (0, _forwardRef.default)(_ContentEditable.default);

/**
 * Generates the inner text field component that could be an input, textarea or editable content
 * depending on the provided props.
 */
const TextFieldInner = _ref => {
  let {
      id,
      visibility,
      multilineType,
      multilineSpellCheck,
      onUpload,
      onChange,
      readOnly,
      rows,
      multiline,
      inputRef,
      type,
      inputMode,
      mask,
      maskOptions,
      autoComplete,
      dataTestId
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const tabIndex = _utils.default.isVisible(visibility) ? 0 : -1;
  const handleInputChange = (0, _react.useCallback)(value => onChange({
    value
  }), [onChange]);
  if (!multiline) {
    return /*#__PURE__*/_react.default.createElement(_reactImask.IMaskInput, (0, _extends2.default)({
      id: id,
      inputRef: inputRef,
      style: readOnly || !_utils.default.isVisible(visibility) ? {
        pointerEvents: 'none'
      } : {},
      type: type,
      inputMode: inputMode,
      autoComplete: autoComplete,
      disabled: visibility === 'disabled',
      readOnly: readOnly,
      tabIndex: tabIndex,
      unmask: !mask,
      mask: mask,
      "data-testid": dataTestId
    }, mask ? {
      onAccept: handleInputChange
    } : {
      onChange
    }, maskOptions, rest));
  }
  return multilineType === 'text' ? /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({
    id: id,
    ref: inputRef,
    rows: rows,
    spellCheck: multilineSpellCheck,
    autoComplete: "off",
    disabled: visibility === 'disabled',
    readOnly: readOnly,
    onChange: onChange,
    "data-testid": dataTestId
  }, rest)) : /*#__PURE__*/_react.default.createElement(ContentEditCom, (0, _extends2.default)({
    id: id,
    ref: inputRef,
    type: multilineType,
    visibility: visibility,
    onUpload: onUpload,
    onChange: onChange,
    tabIndex: tabIndex,
    rows: rows,
    dataTestId: dataTestId
  }, rest));
};
var _default = exports.default = TextFieldInner;